/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class ApiClientBase {
    private readonly config: IAuthClientConfig;

    protected constructor(config: IAuthClientConfig) {
        this.config = config;
    }

    protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
        options.headers = {
          ...options.headers,
          Authorization: this.config.getAuthorization(),
        };
        return Promise.resolve(options);
    };
}

export interface IClient {
    /**
     * @return The OK response
     */
    addressSearch(searchTerm: string): Promise<AddressSuggestionDto[]>;
    /**
     * @return The OK response
     */
    addressValidate(addressId: number): Promise<ValidateAddressResponseDto>;
    /**
     * @param body request body
     * @return The OK response
     */
    calculateCost(body: CalculateCostModel): Promise<CalculateCostResponse>;
    /**
     * @param body request body
     * @return The OK response
     */
    createCart(body: CreateCartModel): Promise<CartCreatedResponse>;
    /**
     * @param promoCode (optional) 
     * @param body request body
     * @return The OK response
     */
    beginSession(promoCode: string | null | undefined, body: SessionBeginRequest): Promise<SessionBeginResponse>;
    /**
     * @return The OK response
     */
    getDeliverySlotsForProductAndAddress(sku: string, addressId: number): Promise<DeliverySlotsIncludeBufferGroupedSummary[]>;
    health(): Promise<void>;
    healthFrontDoor(): Promise<void>;
    /**
     * @param body request body
     * @return The OK response
     */
    updateLead(body: UpdateLeadCommand): Promise<LeadResponse>;
    /**
     * @return The OK response
     */
    productGroup(): Promise<ProductGroupResponseOrderForm[]>;
    /**
     * @return The OK response
     */
    validateCode(code: string, cartId: string): Promise<ValidateCodeResponse>;
    /**
     * @param body request body
     * @return The OK response
     */
    createPurchase(sku: string, body: CreatePurchaseRequest): Promise<CreateSubscriptionResponse>;
    /**
     * @return The OK response
     */
    getAvailableRecipesForSkuAndWeek(sku: string, weekStarting: Date): Promise<RecipeDto[]>;
    /**
     * @return The OK response
     */
    getRecipeDetails(partition: string, recipeNumber: string, version: string, week: Date): Promise<RecipeResponse>;
}

export class Client extends ApiClientBase implements IClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:7071";
    }

    /**
     * @return The OK response
     */
    addressSearch(searchTerm: string): Promise<AddressSuggestionDto[]> {
        let url_ = this.baseUrl + "/signupapi/address/search?";
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddressSearch(_response);
        });
    }

    protected processAddressSearch(response: Response): Promise<AddressSuggestionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressSuggestionDto.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressSuggestionDto[]>(<any>null);
    }

    /**
     * @return The OK response
     */
    addressValidate(addressId: number): Promise<ValidateAddressResponseDto> {
        let url_ = this.baseUrl + "/signupapi/address/{addressId}/validate";
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddressValidate(_response);
        });
    }

    protected processAddressValidate(response: Response): Promise<ValidateAddressResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateAddressResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateAddressResponseDto>(<any>null);
    }

    /**
     * @param body request body
     * @return The OK response
     */
    calculateCost(body: CalculateCostModel): Promise<CalculateCostResponse> {
        let url_ = this.baseUrl + "/signupapi/calculateCost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateCost(_response);
        });
    }

    protected processCalculateCost(response: Response): Promise<CalculateCostResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateCostResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateCostResponse>(<any>null);
    }

    /**
     * @param body request body
     * @return The OK response
     */
    createCart(body: CreateCartModel): Promise<CartCreatedResponse> {
        let url_ = this.baseUrl + "/signupapi/cart/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCart(_response);
        });
    }

    protected processCreateCart(response: Response): Promise<CartCreatedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartCreatedResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CartCreatedResponse>(<any>null);
    }

    /**
     * @param promoCode (optional) 
     * @param body request body
     * @return The OK response
     */
    beginSession(promoCode: string | null | undefined, body: SessionBeginRequest): Promise<SessionBeginResponse> {
        let url_ = this.baseUrl + "/signupapi/session/begin?";
        if (promoCode !== undefined && promoCode !== null)
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBeginSession(_response);
        });
    }

    protected processBeginSession(response: Response): Promise<SessionBeginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionBeginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionBeginResponse>(<any>null);
    }

    /**
     * @return The OK response
     */
    getDeliverySlotsForProductAndAddress(sku: string, addressId: number): Promise<DeliverySlotsIncludeBufferGroupedSummary[]> {
        let url_ = this.baseUrl + "/signupapi/products/{sku}/deliverySlots/{addressId}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeliverySlotsForProductAndAddress(_response);
        });
    }

    protected processGetDeliverySlotsForProductAndAddress(response: Response): Promise<DeliverySlotsIncludeBufferGroupedSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliverySlotsIncludeBufferGroupedSummary.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliverySlotsIncludeBufferGroupedSummary[]>(<any>null);
    }

    health(): Promise<void> {
        let url_ = this.baseUrl + "/_health/availability";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealth(_response);
        });
    }

    protected processHealth(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    healthFrontDoor(): Promise<void> {
        let url_ = this.baseUrl + "/signupapi/_health/frontdoor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealthFrontDoor(_response);
        });
    }

    protected processHealthFrontDoor(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body request body
     * @return The OK response
     */
    updateLead(body: UpdateLeadCommand): Promise<LeadResponse> {
        let url_ = this.baseUrl + "/signupapi/lead/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLead(_response);
        });
    }

    protected processUpdateLead(response: Response): Promise<LeadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadResponse>(<any>null);
    }

    /**
     * @return The OK response
     */
    productGroup(): Promise<ProductGroupResponseOrderForm[]> {
        let url_ = this.baseUrl + "/signupapi/products/grouped/orderform";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductGroup(_response);
        });
    }

    protected processProductGroup(response: Response): Promise<ProductGroupResponseOrderForm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductGroupResponseOrderForm.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductGroupResponseOrderForm[]>(<any>null);
    }

    /**
     * @return The OK response
     */
    validateCode(code: string, cartId: string): Promise<ValidateCodeResponse> {
        let url_ = this.baseUrl + "/signupapi/validateCode/{code}/cart/{cartId}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        if (cartId === undefined || cartId === null)
            throw new Error("The parameter 'cartId' must be defined.");
        url_ = url_.replace("{cartId}", encodeURIComponent("" + cartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateCode(_response);
        });
    }

    protected processValidateCode(response: Response): Promise<ValidateCodeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateCodeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateCodeResponse>(<any>null);
    }

    /**
     * @param body request body
     * @return The OK response
     */
    createPurchase(sku: string, body: CreatePurchaseRequest): Promise<CreateSubscriptionResponse> {
        let url_ = this.baseUrl + "/signupapi/purchase/{sku}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePurchase(_response);
        });
    }

    protected processCreatePurchase(response: Response): Promise<CreateSubscriptionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSubscriptionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Error Response", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateSubscriptionResponse>(<any>null);
    }

    /**
     * @return The OK response
     */
    getAvailableRecipesForSkuAndWeek(sku: string, weekStarting: Date): Promise<RecipeDto[]> {
        let url_ = this.baseUrl + "/signupapi/available-recipes/{sku}/{weekStarting}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        if (weekStarting === undefined || weekStarting === null)
            throw new Error("The parameter 'weekStarting' must be defined.");
        url_ = url_.replace("{weekStarting}", encodeURIComponent(weekStarting ? "" + weekStarting.toJSON() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableRecipesForSkuAndWeek(_response);
        });
    }

    protected processGetAvailableRecipesForSkuAndWeek(response: Response): Promise<RecipeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeDto.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDto[]>(<any>null);
    }

    /**
     * @return The OK response
     */
    getRecipeDetails(partition: string, recipeNumber: string, version: string, week: Date): Promise<RecipeResponse> {
        let url_ = this.baseUrl + "/signupapi/details/{partition}/{recipeNumber}/{version}/{week}";
        if (partition === undefined || partition === null)
            throw new Error("The parameter 'partition' must be defined.");
        url_ = url_.replace("{partition}", encodeURIComponent("" + partition));
        if (recipeNumber === undefined || recipeNumber === null)
            throw new Error("The parameter 'recipeNumber' must be defined.");
        url_ = url_.replace("{recipeNumber}", encodeURIComponent("" + recipeNumber));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent(week ? "" + week.toJSON() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecipeDetails(_response);
        });
    }

    protected processGetRecipeDetails(response: Response): Promise<RecipeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeResponse>(<any>null);
    }
}

export class AddedProductSummaryDto implements IAddedProductSummaryDto {
    sku?: string | undefined;
    name?: string | undefined;
    retailPrice!: number;
    isFree!: boolean;

    constructor(data?: IAddedProductSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["Sku"];
            this.name = _data["Name"];
            this.retailPrice = _data["RetailPrice"];
            this.isFree = _data["IsFree"];
        }
    }

    static fromJS(data: any): AddedProductSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddedProductSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Sku"] = this.sku;
        data["Name"] = this.name;
        data["RetailPrice"] = this.retailPrice;
        data["IsFree"] = this.isFree;
        return data; 
    }
}

export interface IAddedProductSummaryDto {
    sku?: string | undefined;
    name?: string | undefined;
    retailPrice: number;
    isFree: boolean;
}

export class AddProductBenefitDto implements IAddProductBenefitDto {
    product?: ProductSummary | undefined;
    overridePrice!: number;

    constructor(data?: IAddProductBenefitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["Product"] ? ProductSummary.fromJS(_data["Product"]) : <any>undefined;
            this.overridePrice = _data["OverridePrice"];
        }
    }

    static fromJS(data: any): AddProductBenefitDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductBenefitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["OverridePrice"] = this.overridePrice;
        return data; 
    }
}

export interface IAddProductBenefitDto {
    product?: ProductSummary | undefined;
    overridePrice: number;
}

export class AddressSuggestionDto implements IAddressSuggestionDto {
    suggestionId!: number;
    fullAddress?: string | undefined;

    constructor(data?: IAddressSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.suggestionId = _data["SuggestionId"];
            this.fullAddress = _data["FullAddress"];
        }
    }

    static fromJS(data: any): AddressSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SuggestionId"] = this.suggestionId;
        data["FullAddress"] = this.fullAddress;
        return data; 
    }
}

export interface IAddressSuggestionDto {
    suggestionId: number;
    fullAddress?: string | undefined;
}

export class BenefitDto implements IBenefitDto {
    benefitType!: BenefitDtoBenefitType;
    amount!: number;
    message?: string | undefined;
    product?: ProductSummary | undefined;
    consumableFrom!: Date;
    consumableTo?: Date | undefined;
    addProductBenefits?: AddProductBenefitDto[] | undefined;
    priceBenefits?: PriceBenefitDto[] | undefined;

    constructor(data?: IBenefitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.benefitType = BenefitDtoBenefitType._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.benefitType = _data["BenefitType"] !== undefined ? _data["BenefitType"] : BenefitDtoBenefitType._0;
            this.amount = _data["Amount"];
            this.message = _data["Message"];
            this.product = _data["Product"] ? ProductSummary.fromJS(_data["Product"]) : <any>undefined;
            this.consumableFrom = _data["ConsumableFrom"] ? new Date(_data["ConsumableFrom"].toString()) : <any>undefined;
            this.consumableTo = _data["ConsumableTo"] ? new Date(_data["ConsumableTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["AddProductBenefits"])) {
                this.addProductBenefits = [] as any;
                for (let item of _data["AddProductBenefits"])
                    this.addProductBenefits!.push(AddProductBenefitDto.fromJS(item));
            }
            if (Array.isArray(_data["PriceBenefits"])) {
                this.priceBenefits = [] as any;
                for (let item of _data["PriceBenefits"])
                    this.priceBenefits!.push(PriceBenefitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BenefitDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BenefitType"] = this.benefitType;
        data["Amount"] = this.amount;
        data["Message"] = this.message;
        data["Product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["ConsumableFrom"] = this.consumableFrom ? this.consumableFrom.toISOString() : <any>undefined;
        data["ConsumableTo"] = this.consumableTo ? this.consumableTo.toISOString() : <any>undefined;
        if (Array.isArray(this.addProductBenefits)) {
            data["AddProductBenefits"] = [];
            for (let item of this.addProductBenefits)
                data["AddProductBenefits"].push(item.toJSON());
        }
        if (Array.isArray(this.priceBenefits)) {
            data["PriceBenefits"] = [];
            for (let item of this.priceBenefits)
                data["PriceBenefits"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBenefitDto {
    benefitType: BenefitDtoBenefitType;
    amount: number;
    message?: string | undefined;
    product?: ProductSummary | undefined;
    consumableFrom: Date;
    consumableTo?: Date | undefined;
    addProductBenefits?: AddProductBenefitDto[] | undefined;
    priceBenefits?: PriceBenefitDto[] | undefined;
}

export class CalculateCostModel implements ICalculateCostModel {
    cartId?: string | undefined;
    sku?: string | undefined;
    discountCode?: string | undefined;
    discountType?: CalculateCostModelDiscountType | undefined;
    voucherCode?: string | undefined;
    addressId?: number | undefined;

    constructor(data?: ICalculateCostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.discountType = CalculateCostModelDiscountType._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cartId = _data["cartId"];
            this.sku = _data["sku"];
            this.discountCode = _data["discountCode"];
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : CalculateCostModelDiscountType._0;
            this.voucherCode = _data["voucherCode"];
            this.addressId = _data["addressId"];
        }
    }

    static fromJS(data: any): CalculateCostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateCostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartId"] = this.cartId;
        data["sku"] = this.sku;
        data["discountCode"] = this.discountCode;
        data["discountType"] = this.discountType;
        data["voucherCode"] = this.voucherCode;
        data["addressId"] = this.addressId;
        return data; 
    }
}

export interface ICalculateCostModel {
    cartId?: string | undefined;
    sku?: string | undefined;
    discountCode?: string | undefined;
    discountType?: CalculateCostModelDiscountType | undefined;
    voucherCode?: string | undefined;
    addressId?: number | undefined;
}

export class CalculateCostResponse implements ICalculateCostResponse {
    subtotal!: number;
    discount?: DiscountResponse | undefined;
    voucher?: VoucherResponse | undefined;
    shippingTotal!: number;
    total!: number;
    totalDiscount!: number;

    constructor(data?: ICalculateCostResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subtotal = _data["Subtotal"];
            this.discount = _data["Discount"] ? DiscountResponse.fromJS(_data["Discount"]) : <any>undefined;
            this.voucher = _data["Voucher"] ? VoucherResponse.fromJS(_data["Voucher"]) : <any>undefined;
            this.shippingTotal = _data["ShippingTotal"];
            this.total = _data["Total"];
            this.totalDiscount = _data["TotalDiscount"];
        }
    }

    static fromJS(data: any): CalculateCostResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateCostResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Subtotal"] = this.subtotal;
        data["Discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        data["Voucher"] = this.voucher ? this.voucher.toJSON() : <any>undefined;
        data["ShippingTotal"] = this.shippingTotal;
        data["Total"] = this.total;
        data["TotalDiscount"] = this.totalDiscount;
        return data; 
    }
}

export interface ICalculateCostResponse {
    subtotal: number;
    discount?: DiscountResponse | undefined;
    voucher?: VoucherResponse | undefined;
    shippingTotal: number;
    total: number;
    totalDiscount: number;
}

export class CartCreatedResponse implements ICartCreatedResponse {
    cartId?: string | undefined;

    constructor(data?: ICartCreatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cartId = _data["CartId"];
        }
    }

    static fromJS(data: any): CartCreatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CartCreatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CartId"] = this.cartId;
        return data; 
    }
}

export interface ICartCreatedResponse {
    cartId?: string | undefined;
}

export class CreateCartModel implements ICreateCartModel {
    sku?: string | undefined;

    constructor(data?: ICreateCartModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
        }
    }

    static fromJS(data: any): CreateCartModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCartModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        return data; 
    }
}

export interface ICreateCartModel {
    sku?: string | undefined;
}

export class CreatePurchaseRequest implements ICreatePurchaseRequest {
    customerNumber!: string;
    subscription!: SubscriptionDetailRequest;
    referralCode?: string | undefined;
    promoGroupId?: number | undefined;
    voucherId?: number | undefined;
    referer?: string | undefined;

    constructor(data?: ICreatePurchaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subscription = new SubscriptionDetailRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerNumber = _data["customerNumber"];
            this.subscription = _data["subscription"] ? SubscriptionDetailRequest.fromJS(_data["subscription"]) : new SubscriptionDetailRequest();
            this.referralCode = _data["referralCode"];
            this.promoGroupId = _data["promoGroupId"];
            this.voucherId = _data["voucherId"];
            this.referer = _data["referer"];
        }
    }

    static fromJS(data: any): CreatePurchaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerNumber"] = this.customerNumber;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        data["referralCode"] = this.referralCode;
        data["promoGroupId"] = this.promoGroupId;
        data["voucherId"] = this.voucherId;
        data["referer"] = this.referer;
        return data; 
    }
}

export interface ICreatePurchaseRequest {
    customerNumber: string;
    subscription: SubscriptionDetailRequest;
    referralCode?: string | undefined;
    promoGroupId?: number | undefined;
    voucherId?: number | undefined;
    referer?: string | undefined;
}

export class CreateSubscriptionResponse implements ICreateSubscriptionResponse {
    redirectUri?: string | undefined;
    subscriptionNumber!: string;

    constructor(data?: ICreateSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redirectUri = _data["redirectUri"];
            this.subscriptionNumber = _data["subscriptionNumber"];
        }
    }

    static fromJS(data: any): CreateSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redirectUri"] = this.redirectUri;
        data["subscriptionNumber"] = this.subscriptionNumber;
        return data; 
    }
}

export interface ICreateSubscriptionResponse {
    redirectUri?: string | undefined;
    subscriptionNumber: string;
}

export class CustomerSummary implements ICustomerSummary {
    customerNumber?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: ICustomerSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerNumber = _data["CustomerNumber"];
            this.fullName = _data["FullName"];
        }
    }

    static fromJS(data: any): CustomerSummary {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerNumber"] = this.customerNumber;
        data["FullName"] = this.fullName;
        return data; 
    }
}

export interface ICustomerSummary {
    customerNumber?: string | undefined;
    fullName?: string | undefined;
}

export class DeliverySlotsGroupedSummary implements IDeliverySlotsGroupedSummary {
    deliveryDay!: DeliverySlotsGroupedSummaryDeliveryDay;
    deliverySlots?: ProductDeliverySlotDto[] | undefined;

    constructor(data?: IDeliverySlotsGroupedSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.deliveryDay = DeliverySlotsGroupedSummaryDeliveryDay._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryDay = _data["DeliveryDay"] !== undefined ? _data["DeliveryDay"] : DeliverySlotsGroupedSummaryDeliveryDay._0;
            if (Array.isArray(_data["DeliverySlots"])) {
                this.deliverySlots = [] as any;
                for (let item of _data["DeliverySlots"])
                    this.deliverySlots!.push(ProductDeliverySlotDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeliverySlotsGroupedSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DeliverySlotsGroupedSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DeliveryDay"] = this.deliveryDay;
        if (Array.isArray(this.deliverySlots)) {
            data["DeliverySlots"] = [];
            for (let item of this.deliverySlots)
                data["DeliverySlots"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeliverySlotsGroupedSummary {
    deliveryDay: DeliverySlotsGroupedSummaryDeliveryDay;
    deliverySlots?: ProductDeliverySlotDto[] | undefined;
}

export class DeliverySlotsIncludeBufferGroupedSummary implements IDeliverySlotsIncludeBufferGroupedSummary {
    bufferDeliverySlots?: DeliverySlotsGroupedSummary[] | undefined;
    regularDeliverySlots?: DeliverySlotsGroupedSummary[] | undefined;

    constructor(data?: IDeliverySlotsIncludeBufferGroupedSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["BufferDeliverySlots"])) {
                this.bufferDeliverySlots = [] as any;
                for (let item of _data["BufferDeliverySlots"])
                    this.bufferDeliverySlots!.push(DeliverySlotsGroupedSummary.fromJS(item));
            }
            if (Array.isArray(_data["RegularDeliverySlots"])) {
                this.regularDeliverySlots = [] as any;
                for (let item of _data["RegularDeliverySlots"])
                    this.regularDeliverySlots!.push(DeliverySlotsGroupedSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeliverySlotsIncludeBufferGroupedSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DeliverySlotsIncludeBufferGroupedSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bufferDeliverySlots)) {
            data["BufferDeliverySlots"] = [];
            for (let item of this.bufferDeliverySlots)
                data["BufferDeliverySlots"].push(item.toJSON());
        }
        if (Array.isArray(this.regularDeliverySlots)) {
            data["RegularDeliverySlots"] = [];
            for (let item of this.regularDeliverySlots)
                data["RegularDeliverySlots"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeliverySlotsIncludeBufferGroupedSummary {
    bufferDeliverySlots?: DeliverySlotsGroupedSummary[] | undefined;
    regularDeliverySlots?: DeliverySlotsGroupedSummary[] | undefined;
}

export class Discount2 implements IDiscount2 {
    code?: string | undefined;
    discountType!: Discount2DiscountType;
    message?: string | undefined;
    benefits?: BenefitDto[] | undefined;

    constructor(data?: IDiscount2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.discountType = Discount2DiscountType._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.discountType = _data["DiscountType"] !== undefined ? _data["DiscountType"] : Discount2DiscountType._0;
            this.message = _data["Message"];
            if (Array.isArray(_data["Benefits"])) {
                this.benefits = [] as any;
                for (let item of _data["Benefits"])
                    this.benefits!.push(BenefitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Discount2 {
        data = typeof data === 'object' ? data : {};
        let result = new Discount2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["DiscountType"] = this.discountType;
        data["Message"] = this.message;
        if (Array.isArray(this.benefits)) {
            data["Benefits"] = [];
            for (let item of this.benefits)
                data["Benefits"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDiscount2 {
    code?: string | undefined;
    discountType: Discount2DiscountType;
    message?: string | undefined;
    benefits?: BenefitDto[] | undefined;
}

export class DiscountResponse implements IDiscountResponse {
    code?: string | undefined;
    message?: string | undefined;
    valueOff!: number;
    product?: ProductSummary | undefined;
    productSummaries?: AddedProductSummaryDto[] | undefined;

    constructor(data?: IDiscountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.message = _data["Message"];
            this.valueOff = _data["ValueOff"];
            this.product = _data["Product"] ? ProductSummary.fromJS(_data["Product"]) : <any>undefined;
            if (Array.isArray(_data["ProductSummaries"])) {
                this.productSummaries = [] as any;
                for (let item of _data["ProductSummaries"])
                    this.productSummaries!.push(AddedProductSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiscountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Message"] = this.message;
        data["ValueOff"] = this.valueOff;
        data["Product"] = this.product ? this.product.toJSON() : <any>undefined;
        if (Array.isArray(this.productSummaries)) {
            data["ProductSummaries"] = [];
            for (let item of this.productSummaries)
                data["ProductSummaries"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDiscountResponse {
    code?: string | undefined;
    message?: string | undefined;
    valueOff: number;
    product?: ProductSummary | undefined;
    productSummaries?: AddedProductSummaryDto[] | undefined;
}

export class ErrorResponse implements IErrorResponse {
    code?: string | undefined;
    message?: string | undefined;

    constructor(data?: IErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data; 
    }
}

export interface IErrorResponse {
    code?: string | undefined;
    message?: string | undefined;
}

export class IngredientGroupResponse implements IIngredientGroupResponse {
    name?: string | undefined;
    ingredients?: IngredientResponse[] | undefined;

    constructor(data?: IIngredientGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            if (Array.isArray(_data["Ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["Ingredients"])
                    this.ingredients!.push(IngredientResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IngredientGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        if (Array.isArray(this.ingredients)) {
            data["Ingredients"] = [];
            for (let item of this.ingredients)
                data["Ingredients"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIngredientGroupResponse {
    name?: string | undefined;
    ingredients?: IngredientResponse[] | undefined;
}

export class IngredientResponse implements IIngredientResponse {
    ingredientType!: IngredientResponseIngredientType;
    description?: string | undefined;

    constructor(data?: IIngredientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ingredientType = IngredientResponseIngredientType._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingredientType = _data["IngredientType"] !== undefined ? _data["IngredientType"] : IngredientResponseIngredientType._0;
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): IngredientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IngredientType"] = this.ingredientType;
        data["Description"] = this.description;
        return data; 
    }
}

export interface IIngredientResponse {
    ingredientType: IngredientResponseIngredientType;
    description?: string | undefined;
}

export class ItemDisplayPriceResponse implements IItemDisplayPriceResponse {
    itemPrice!: number;
    deliveryPrice!: number;
    totalPrice!: number;
    serves!: number;
    itemPricePerServe!: number;
    totalPricePerServe!: number;

    constructor(data?: IItemDisplayPriceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemPrice = _data["ItemPrice"];
            this.deliveryPrice = _data["DeliveryPrice"];
            this.totalPrice = _data["TotalPrice"];
            this.serves = _data["Serves"];
            this.itemPricePerServe = _data["ItemPricePerServe"];
            this.totalPricePerServe = _data["TotalPricePerServe"];
        }
    }

    static fromJS(data: any): ItemDisplayPriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDisplayPriceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ItemPrice"] = this.itemPrice;
        data["DeliveryPrice"] = this.deliveryPrice;
        data["TotalPrice"] = this.totalPrice;
        data["Serves"] = this.serves;
        data["ItemPricePerServe"] = this.itemPricePerServe;
        data["TotalPricePerServe"] = this.totalPricePerServe;
        return data; 
    }
}

export interface IItemDisplayPriceResponse {
    itemPrice: number;
    deliveryPrice: number;
    totalPrice: number;
    serves: number;
    itemPricePerServe: number;
    totalPricePerServe: number;
}

export class LeadResponse implements ILeadResponse {
    customerNumber?: string | undefined;

    constructor(data?: ILeadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerNumber = _data["CustomerNumber"];
        }
    }

    static fromJS(data: any): LeadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LeadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerNumber"] = this.customerNumber;
        return data; 
    }
}

export interface ILeadResponse {
    customerNumber?: string | undefined;
}

export class NutritionResponse implements INutritionResponse {
    code?: string | undefined;
    label?: string | undefined;
    value?: number | undefined;
    unit?: string | undefined;

    constructor(data?: INutritionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.label = _data["Label"];
            this.value = _data["Value"];
            this.unit = _data["Unit"];
        }
    }

    static fromJS(data: any): NutritionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Label"] = this.label;
        data["Value"] = this.value;
        data["Unit"] = this.unit;
        return data; 
    }
}

export interface INutritionResponse {
    code?: string | undefined;
    label?: string | undefined;
    value?: number | undefined;
    unit?: string | undefined;
}

export class PriceBenefitDto implements IPriceBenefitDto {
    benefitType!: PriceBenefitDtoBenefitType;
    benefitValue!: number;
    selector?: string | undefined;
    productSelectorType!: PriceBenefitDtoProductSelectorType;

    constructor(data?: IPriceBenefitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.benefitType = PriceBenefitDtoBenefitType._0;
            this.productSelectorType = PriceBenefitDtoProductSelectorType._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.benefitType = _data["BenefitType"] !== undefined ? _data["BenefitType"] : PriceBenefitDtoBenefitType._0;
            this.benefitValue = _data["BenefitValue"];
            this.selector = _data["Selector"];
            this.productSelectorType = _data["ProductSelectorType"] !== undefined ? _data["ProductSelectorType"] : PriceBenefitDtoProductSelectorType._0;
        }
    }

    static fromJS(data: any): PriceBenefitDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceBenefitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BenefitType"] = this.benefitType;
        data["BenefitValue"] = this.benefitValue;
        data["Selector"] = this.selector;
        data["ProductSelectorType"] = this.productSelectorType;
        return data; 
    }
}

export interface IPriceBenefitDto {
    benefitType: PriceBenefitDtoBenefitType;
    benefitValue: number;
    selector?: string | undefined;
    productSelectorType: PriceBenefitDtoProductSelectorType;
}

export class ProductDeliverySlotDto implements IProductDeliverySlotDto {
    deliverySlotId!: number;
    deliveryDay!: ProductDeliverySlotDtoDeliveryDay;
    description?: string | undefined;
    availableFrom!: TimeSpan;
    availableTo!: TimeSpan;
    nextVirtualDeliveryDate!: Date;
    nextVirtualDeliveryDateId!: number;
    sortOrder!: number;

    constructor(data?: IProductDeliverySlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.deliveryDay = ProductDeliverySlotDtoDeliveryDay._0;
            this.availableFrom = new TimeSpan();
            this.availableTo = new TimeSpan();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliverySlotId = _data["DeliverySlotId"];
            this.deliveryDay = _data["DeliveryDay"] !== undefined ? _data["DeliveryDay"] : ProductDeliverySlotDtoDeliveryDay._0;
            this.description = _data["Description"];
            this.availableFrom = _data["AvailableFrom"] ? TimeSpan.fromJS(_data["AvailableFrom"]) : new TimeSpan();
            this.availableTo = _data["AvailableTo"] ? TimeSpan.fromJS(_data["AvailableTo"]) : new TimeSpan();
            this.nextVirtualDeliveryDate = _data["NextVirtualDeliveryDate"] ? new Date(_data["NextVirtualDeliveryDate"].toString()) : <any>undefined;
            this.nextVirtualDeliveryDateId = _data["NextVirtualDeliveryDateId"];
            this.sortOrder = _data["SortOrder"];
        }
    }

    static fromJS(data: any): ProductDeliverySlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDeliverySlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DeliverySlotId"] = this.deliverySlotId;
        data["DeliveryDay"] = this.deliveryDay;
        data["Description"] = this.description;
        data["AvailableFrom"] = this.availableFrom ? this.availableFrom.toJSON() : <any>undefined;
        data["AvailableTo"] = this.availableTo ? this.availableTo.toJSON() : <any>undefined;
        data["NextVirtualDeliveryDate"] = this.nextVirtualDeliveryDate ? this.nextVirtualDeliveryDate.toISOString() : <any>undefined;
        data["NextVirtualDeliveryDateId"] = this.nextVirtualDeliveryDateId;
        data["SortOrder"] = this.sortOrder;
        return data; 
    }
}

export interface IProductDeliverySlotDto {
    deliverySlotId: number;
    deliveryDay: ProductDeliverySlotDtoDeliveryDay;
    description?: string | undefined;
    availableFrom: TimeSpan;
    availableTo: TimeSpan;
    nextVirtualDeliveryDate: Date;
    nextVirtualDeliveryDateId: number;
    sortOrder: number;
}

export class ProductGroupResponseOrderForm implements IProductGroupResponseOrderForm {
    name?: string | undefined;
    shortDisplayDescription?: string | undefined;
    blurb?: string | undefined;
    tag?: string | undefined;
    iconUrl?: string | undefined;
    sortOrder!: number;
    productOptions?: ProductSummaryResponseOrderForm[] | undefined;

    constructor(data?: IProductGroupResponseOrderForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.shortDisplayDescription = _data["ShortDisplayDescription"];
            this.blurb = _data["Blurb"];
            this.tag = _data["Tag"];
            this.iconUrl = _data["IconUrl"];
            this.sortOrder = _data["SortOrder"];
            if (Array.isArray(_data["ProductOptions"])) {
                this.productOptions = [] as any;
                for (let item of _data["ProductOptions"])
                    this.productOptions!.push(ProductSummaryResponseOrderForm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductGroupResponseOrderForm {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroupResponseOrderForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["ShortDisplayDescription"] = this.shortDisplayDescription;
        data["Blurb"] = this.blurb;
        data["Tag"] = this.tag;
        data["IconUrl"] = this.iconUrl;
        data["SortOrder"] = this.sortOrder;
        if (Array.isArray(this.productOptions)) {
            data["ProductOptions"] = [];
            for (let item of this.productOptions)
                data["ProductOptions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductGroupResponseOrderForm {
    name?: string | undefined;
    shortDisplayDescription?: string | undefined;
    blurb?: string | undefined;
    tag?: string | undefined;
    iconUrl?: string | undefined;
    sortOrder: number;
    productOptions?: ProductSummaryResponseOrderForm[] | undefined;
}

export class ProductSummary implements IProductSummary {
    name?: string | undefined;
    productOptionName?: string | undefined;
    productName?: string | undefined;
    sku?: string | undefined;
    itemNumber?: string | undefined;
    numberOfPlates?: number | undefined;
    totalPrice!: number;
    deliveryPrice?: number | undefined;

    constructor(data?: IProductSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.productOptionName = _data["ProductOptionName"];
            this.productName = _data["ProductName"];
            this.sku = _data["Sku"];
            this.itemNumber = _data["ItemNumber"];
            this.numberOfPlates = _data["NumberOfPlates"];
            this.totalPrice = _data["TotalPrice"];
            this.deliveryPrice = _data["DeliveryPrice"];
        }
    }

    static fromJS(data: any): ProductSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["ProductOptionName"] = this.productOptionName;
        data["ProductName"] = this.productName;
        data["Sku"] = this.sku;
        data["ItemNumber"] = this.itemNumber;
        data["NumberOfPlates"] = this.numberOfPlates;
        data["TotalPrice"] = this.totalPrice;
        data["DeliveryPrice"] = this.deliveryPrice;
        return data; 
    }
}

export interface IProductSummary {
    name?: string | undefined;
    productOptionName?: string | undefined;
    productName?: string | undefined;
    sku?: string | undefined;
    itemNumber?: string | undefined;
    numberOfPlates?: number | undefined;
    totalPrice: number;
    deliveryPrice?: number | undefined;
}

export class ProductSummaryResponseOrderForm implements IProductSummaryResponseOrderForm {
    name?: string | undefined;
    sku?: string | undefined;
    nights!: number;
    people!: number;
    totalPrice!: number;
    deliveryPrice?: number | undefined;
    pricePerPlate?: number | undefined;

    constructor(data?: IProductSummaryResponseOrderForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.sku = _data["Sku"];
            this.nights = _data["Nights"];
            this.people = _data["People"];
            this.totalPrice = _data["TotalPrice"];
            this.deliveryPrice = _data["DeliveryPrice"];
            this.pricePerPlate = _data["PricePerPlate"];
        }
    }

    static fromJS(data: any): ProductSummaryResponseOrderForm {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSummaryResponseOrderForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Sku"] = this.sku;
        data["Nights"] = this.nights;
        data["People"] = this.people;
        data["TotalPrice"] = this.totalPrice;
        data["DeliveryPrice"] = this.deliveryPrice;
        data["PricePerPlate"] = this.pricePerPlate;
        return data; 
    }
}

export interface IProductSummaryResponseOrderForm {
    name?: string | undefined;
    sku?: string | undefined;
    nights: number;
    people: number;
    totalPrice: number;
    deliveryPrice?: number | undefined;
    pricePerPlate?: number | undefined;
}

export class PromoDto implements IPromoDto {
    promoGroupId!: number;
    forNewOrReturningCustomers!: boolean;
    validForProducts?: ProductSummary[] | undefined;
    redeemableFrom!: Date;
    redeemableTo!: Date;
    bannerUrlSmall?: string | undefined;
    bannerUrlMedium?: string | undefined;
    bannerUrlLarge?: string | undefined;
    code?: string | undefined;
    message?: string | undefined;
    discountType!: PromoDtoDiscountType;
    benefits?: BenefitDto[] | undefined;

    constructor(data?: IPromoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.discountType = PromoDtoDiscountType._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promoGroupId = _data["PromoGroupId"];
            this.forNewOrReturningCustomers = _data["ForNewOrReturningCustomers"];
            if (Array.isArray(_data["ValidForProducts"])) {
                this.validForProducts = [] as any;
                for (let item of _data["ValidForProducts"])
                    this.validForProducts!.push(ProductSummary.fromJS(item));
            }
            this.redeemableFrom = _data["RedeemableFrom"] ? new Date(_data["RedeemableFrom"].toString()) : <any>undefined;
            this.redeemableTo = _data["RedeemableTo"] ? new Date(_data["RedeemableTo"].toString()) : <any>undefined;
            this.bannerUrlSmall = _data["BannerUrlSmall"];
            this.bannerUrlMedium = _data["BannerUrlMedium"];
            this.bannerUrlLarge = _data["BannerUrlLarge"];
            this.code = _data["Code"];
            this.message = _data["Message"];
            this.discountType = _data["DiscountType"] !== undefined ? _data["DiscountType"] : PromoDtoDiscountType._0;
            if (Array.isArray(_data["Benefits"])) {
                this.benefits = [] as any;
                for (let item of _data["Benefits"])
                    this.benefits!.push(BenefitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PromoGroupId"] = this.promoGroupId;
        data["ForNewOrReturningCustomers"] = this.forNewOrReturningCustomers;
        if (Array.isArray(this.validForProducts)) {
            data["ValidForProducts"] = [];
            for (let item of this.validForProducts)
                data["ValidForProducts"].push(item.toJSON());
        }
        data["RedeemableFrom"] = this.redeemableFrom ? this.redeemableFrom.toISOString() : <any>undefined;
        data["RedeemableTo"] = this.redeemableTo ? this.redeemableTo.toISOString() : <any>undefined;
        data["BannerUrlSmall"] = this.bannerUrlSmall;
        data["BannerUrlMedium"] = this.bannerUrlMedium;
        data["BannerUrlLarge"] = this.bannerUrlLarge;
        data["Code"] = this.code;
        data["Message"] = this.message;
        data["DiscountType"] = this.discountType;
        if (Array.isArray(this.benefits)) {
            data["Benefits"] = [];
            for (let item of this.benefits)
                data["Benefits"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromoDto {
    promoGroupId: number;
    forNewOrReturningCustomers: boolean;
    validForProducts?: ProductSummary[] | undefined;
    redeemableFrom: Date;
    redeemableTo: Date;
    bannerUrlSmall?: string | undefined;
    bannerUrlMedium?: string | undefined;
    bannerUrlLarge?: string | undefined;
    code?: string | undefined;
    message?: string | undefined;
    discountType: PromoDtoDiscountType;
    benefits?: BenefitDto[] | undefined;
}

export class RecipeDto implements IRecipeDto {
    imageUrl?: string | undefined;
    title?: string | undefined;
    subtitle?: string | undefined;
    readyInTime?: number | undefined;
    recipeNumber?: string | undefined;
    recipePartition?: string | undefined;
    recipeVersion?: string | undefined;
    badge?: string | undefined;
    tags?: string[] | undefined;
    stockAvailability!: RecipeDtoStockAvailability;
    recipeCategoryId?: number | undefined;
    unitSurcharge?: number | undefined;
    quantity!: number;

    constructor(data?: IRecipeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.stockAvailability = RecipeDtoStockAvailability._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["ImageUrl"];
            this.title = _data["Title"];
            this.subtitle = _data["Subtitle"];
            this.readyInTime = _data["ReadyInTime"];
            this.recipeNumber = _data["RecipeNumber"];
            this.recipePartition = _data["RecipePartition"];
            this.recipeVersion = _data["RecipeVersion"];
            this.badge = _data["Badge"];
            if (Array.isArray(_data["Tags"])) {
                this.tags = [] as any;
                for (let item of _data["Tags"])
                    this.tags!.push(item);
            }
            this.stockAvailability = _data["StockAvailability"] !== undefined ? _data["StockAvailability"] : RecipeDtoStockAvailability._0;
            this.recipeCategoryId = _data["RecipeCategoryId"];
            this.unitSurcharge = _data["UnitSurcharge"];
            this.quantity = _data["Quantity"];
        }
    }

    static fromJS(data: any): RecipeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ImageUrl"] = this.imageUrl;
        data["Title"] = this.title;
        data["Subtitle"] = this.subtitle;
        data["ReadyInTime"] = this.readyInTime;
        data["RecipeNumber"] = this.recipeNumber;
        data["RecipePartition"] = this.recipePartition;
        data["RecipeVersion"] = this.recipeVersion;
        data["Badge"] = this.badge;
        if (Array.isArray(this.tags)) {
            data["Tags"] = [];
            for (let item of this.tags)
                data["Tags"].push(item);
        }
        data["StockAvailability"] = this.stockAvailability;
        data["RecipeCategoryId"] = this.recipeCategoryId;
        data["UnitSurcharge"] = this.unitSurcharge;
        data["Quantity"] = this.quantity;
        return data; 
    }
}

export interface IRecipeDto {
    imageUrl?: string | undefined;
    title?: string | undefined;
    subtitle?: string | undefined;
    readyInTime?: number | undefined;
    recipeNumber?: string | undefined;
    recipePartition?: string | undefined;
    recipeVersion?: string | undefined;
    badge?: string | undefined;
    tags?: string[] | undefined;
    stockAvailability: RecipeDtoStockAvailability;
    recipeCategoryId?: number | undefined;
    unitSurcharge?: number | undefined;
    quantity: number;
}

export class RecipePricingResponse implements IRecipePricingResponse {
    listPrice?: ItemDisplayPriceResponse | undefined;
    salePrice?: SaleDisplayPriceResponse | undefined;
    hasDiscount!: boolean;

    constructor(data?: IRecipePricingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listPrice = _data["ListPrice"] ? ItemDisplayPriceResponse.fromJS(_data["ListPrice"]) : <any>undefined;
            this.salePrice = _data["SalePrice"] ? SaleDisplayPriceResponse.fromJS(_data["SalePrice"]) : <any>undefined;
            this.hasDiscount = _data["HasDiscount"];
        }
    }

    static fromJS(data: any): RecipePricingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecipePricingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ListPrice"] = this.listPrice ? this.listPrice.toJSON() : <any>undefined;
        data["SalePrice"] = this.salePrice ? this.salePrice.toJSON() : <any>undefined;
        data["HasDiscount"] = this.hasDiscount;
        return data; 
    }
}

export interface IRecipePricingResponse {
    listPrice?: ItemDisplayPriceResponse | undefined;
    salePrice?: SaleDisplayPriceResponse | undefined;
    hasDiscount: boolean;
}

export class RecipeResponse implements IRecipeResponse {
    recipeNumber?: string | undefined;
    recipeVersion?: string | undefined;
    recipePartition?: string | undefined;
    allergens?: string[] | undefined;
    composition?: string | undefined;
    ingredientGroups?: IngredientGroupResponse[] | undefined;
    numberOfServes?: string | undefined;
    readyInTime?: number | undefined;
    badge?: string | undefined;
    tags?: string[] | undefined;
    description?: string | undefined;
    sortOrder?: number | undefined;
    type?: string | undefined;
    categoryCode?: string | undefined;
    imageUrl?: string | undefined;
    brand?: string | undefined;
    subtitle?: string | undefined;
    title?: string | undefined;
    recipeDocumentId?: string | undefined;
    steps?: StepResponse[] | undefined;
    nutritionalInformation?: NutritionResponse[] | undefined;
    isFavourite!: boolean;
    surcharge?: RecipePricingResponse | undefined;
    recipeCardStyleName?: string | undefined;
    maximumQuantity!: number;
    recipeId?: string | undefined;
    version?: string | undefined;
    partitionKey?: string | undefined;

    constructor(data?: IRecipeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipeNumber = _data["RecipeNumber"];
            this.recipeVersion = _data["RecipeVersion"];
            this.recipePartition = _data["RecipePartition"];
            if (Array.isArray(_data["Allergens"])) {
                this.allergens = [] as any;
                for (let item of _data["Allergens"])
                    this.allergens!.push(item);
            }
            this.composition = _data["Composition"];
            if (Array.isArray(_data["IngredientGroups"])) {
                this.ingredientGroups = [] as any;
                for (let item of _data["IngredientGroups"])
                    this.ingredientGroups!.push(IngredientGroupResponse.fromJS(item));
            }
            this.numberOfServes = _data["NumberOfServes"];
            this.readyInTime = _data["ReadyInTime"];
            this.badge = _data["Badge"];
            if (Array.isArray(_data["Tags"])) {
                this.tags = [] as any;
                for (let item of _data["Tags"])
                    this.tags!.push(item);
            }
            this.description = _data["Description"];
            this.sortOrder = _data["SortOrder"];
            this.type = _data["Type"];
            this.categoryCode = _data["CategoryCode"];
            this.imageUrl = _data["ImageUrl"];
            this.brand = _data["Brand"];
            this.subtitle = _data["Subtitle"];
            this.title = _data["Title"];
            this.recipeDocumentId = _data["RecipeDocumentId"];
            if (Array.isArray(_data["Steps"])) {
                this.steps = [] as any;
                for (let item of _data["Steps"])
                    this.steps!.push(StepResponse.fromJS(item));
            }
            if (Array.isArray(_data["NutritionalInformation"])) {
                this.nutritionalInformation = [] as any;
                for (let item of _data["NutritionalInformation"])
                    this.nutritionalInformation!.push(NutritionResponse.fromJS(item));
            }
            this.isFavourite = _data["IsFavourite"];
            this.surcharge = _data["Surcharge"] ? RecipePricingResponse.fromJS(_data["Surcharge"]) : <any>undefined;
            this.recipeCardStyleName = _data["RecipeCardStyleName"];
            this.maximumQuantity = _data["MaximumQuantity"];
            this.recipeId = _data["RecipeId"];
            this.version = _data["Version"];
            this.partitionKey = _data["PartitionKey"];
        }
    }

    static fromJS(data: any): RecipeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RecipeNumber"] = this.recipeNumber;
        data["RecipeVersion"] = this.recipeVersion;
        data["RecipePartition"] = this.recipePartition;
        if (Array.isArray(this.allergens)) {
            data["Allergens"] = [];
            for (let item of this.allergens)
                data["Allergens"].push(item);
        }
        data["Composition"] = this.composition;
        if (Array.isArray(this.ingredientGroups)) {
            data["IngredientGroups"] = [];
            for (let item of this.ingredientGroups)
                data["IngredientGroups"].push(item.toJSON());
        }
        data["NumberOfServes"] = this.numberOfServes;
        data["ReadyInTime"] = this.readyInTime;
        data["Badge"] = this.badge;
        if (Array.isArray(this.tags)) {
            data["Tags"] = [];
            for (let item of this.tags)
                data["Tags"].push(item);
        }
        data["Description"] = this.description;
        data["SortOrder"] = this.sortOrder;
        data["Type"] = this.type;
        data["CategoryCode"] = this.categoryCode;
        data["ImageUrl"] = this.imageUrl;
        data["Brand"] = this.brand;
        data["Subtitle"] = this.subtitle;
        data["Title"] = this.title;
        data["RecipeDocumentId"] = this.recipeDocumentId;
        if (Array.isArray(this.steps)) {
            data["Steps"] = [];
            for (let item of this.steps)
                data["Steps"].push(item.toJSON());
        }
        if (Array.isArray(this.nutritionalInformation)) {
            data["NutritionalInformation"] = [];
            for (let item of this.nutritionalInformation)
                data["NutritionalInformation"].push(item.toJSON());
        }
        data["IsFavourite"] = this.isFavourite;
        data["Surcharge"] = this.surcharge ? this.surcharge.toJSON() : <any>undefined;
        data["RecipeCardStyleName"] = this.recipeCardStyleName;
        data["MaximumQuantity"] = this.maximumQuantity;
        data["RecipeId"] = this.recipeId;
        data["Version"] = this.version;
        data["PartitionKey"] = this.partitionKey;
        return data; 
    }
}

export interface IRecipeResponse {
    recipeNumber?: string | undefined;
    recipeVersion?: string | undefined;
    recipePartition?: string | undefined;
    allergens?: string[] | undefined;
    composition?: string | undefined;
    ingredientGroups?: IngredientGroupResponse[] | undefined;
    numberOfServes?: string | undefined;
    readyInTime?: number | undefined;
    badge?: string | undefined;
    tags?: string[] | undefined;
    description?: string | undefined;
    sortOrder?: number | undefined;
    type?: string | undefined;
    categoryCode?: string | undefined;
    imageUrl?: string | undefined;
    brand?: string | undefined;
    subtitle?: string | undefined;
    title?: string | undefined;
    recipeDocumentId?: string | undefined;
    steps?: StepResponse[] | undefined;
    nutritionalInformation?: NutritionResponse[] | undefined;
    isFavourite: boolean;
    surcharge?: RecipePricingResponse | undefined;
    recipeCardStyleName?: string | undefined;
    maximumQuantity: number;
    recipeId?: string | undefined;
    version?: string | undefined;
    partitionKey?: string | undefined;
}

export class ReferAFriendDto implements IReferAFriendDto {
    referredBy?: CustomerSummary | undefined;
    code?: string | undefined;
    message?: string | undefined;
    discountType!: ReferAFriendDtoDiscountType;
    benefits?: BenefitDto[] | undefined;

    constructor(data?: IReferAFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.discountType = ReferAFriendDtoDiscountType._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referredBy = _data["ReferredBy"] ? CustomerSummary.fromJS(_data["ReferredBy"]) : <any>undefined;
            this.code = _data["Code"];
            this.message = _data["Message"];
            this.discountType = _data["DiscountType"] !== undefined ? _data["DiscountType"] : ReferAFriendDtoDiscountType._0;
            if (Array.isArray(_data["Benefits"])) {
                this.benefits = [] as any;
                for (let item of _data["Benefits"])
                    this.benefits!.push(BenefitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReferAFriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferAFriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReferredBy"] = this.referredBy ? this.referredBy.toJSON() : <any>undefined;
        data["Code"] = this.code;
        data["Message"] = this.message;
        data["DiscountType"] = this.discountType;
        if (Array.isArray(this.benefits)) {
            data["Benefits"] = [];
            for (let item of this.benefits)
                data["Benefits"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IReferAFriendDto {
    referredBy?: CustomerSummary | undefined;
    code?: string | undefined;
    message?: string | undefined;
    discountType: ReferAFriendDtoDiscountType;
    benefits?: BenefitDto[] | undefined;
}

export class SaleDisplayPriceResponse implements ISaleDisplayPriceResponse {
    hasDiscount!: boolean;
    discountSource!: SaleDisplayPriceResponseDiscountSource;
    promoCodeApplied?: string | undefined;
    itemPrice!: number;
    deliveryPrice!: number;
    totalPrice!: number;
    serves!: number;
    itemPricePerServe!: number;
    totalPricePerServe!: number;

    constructor(data?: ISaleDisplayPriceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.discountSource = SaleDisplayPriceResponseDiscountSource._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasDiscount = _data["HasDiscount"];
            this.discountSource = _data["DiscountSource"] !== undefined ? _data["DiscountSource"] : SaleDisplayPriceResponseDiscountSource._0;
            this.promoCodeApplied = _data["PromoCodeApplied"];
            this.itemPrice = _data["ItemPrice"];
            this.deliveryPrice = _data["DeliveryPrice"];
            this.totalPrice = _data["TotalPrice"];
            this.serves = _data["Serves"];
            this.itemPricePerServe = _data["ItemPricePerServe"];
            this.totalPricePerServe = _data["TotalPricePerServe"];
        }
    }

    static fromJS(data: any): SaleDisplayPriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaleDisplayPriceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HasDiscount"] = this.hasDiscount;
        data["DiscountSource"] = this.discountSource;
        data["PromoCodeApplied"] = this.promoCodeApplied;
        data["ItemPrice"] = this.itemPrice;
        data["DeliveryPrice"] = this.deliveryPrice;
        data["TotalPrice"] = this.totalPrice;
        data["Serves"] = this.serves;
        data["ItemPricePerServe"] = this.itemPricePerServe;
        data["TotalPricePerServe"] = this.totalPricePerServe;
        return data; 
    }
}

export interface ISaleDisplayPriceResponse {
    hasDiscount: boolean;
    discountSource: SaleDisplayPriceResponseDiscountSource;
    promoCodeApplied?: string | undefined;
    itemPrice: number;
    deliveryPrice: number;
    totalPrice: number;
    serves: number;
    itemPricePerServe: number;
    totalPricePerServe: number;
}

export class SessionBeginRequest implements ISessionBeginRequest {
    email!: string;
    sku?: string | undefined;

    constructor(data?: ISessionBeginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.sku = _data["sku"];
        }
    }

    static fromJS(data: any): SessionBeginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SessionBeginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["sku"] = this.sku;
        return data; 
    }
}

export interface ISessionBeginRequest {
    email: string;
    sku?: string | undefined;
}

export class SessionBeginResponse implements ISessionBeginResponse {
    email?: string | undefined;
    customerNumber?: string | undefined;
    customerRedirectUrl?: string | undefined;
    isCustomer!: boolean;
    hasLogin!: boolean;

    constructor(data?: ISessionBeginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.customerNumber = _data["CustomerNumber"];
            this.customerRedirectUrl = _data["CustomerRedirectUrl"];
            this.isCustomer = _data["IsCustomer"];
            this.hasLogin = _data["HasLogin"];
        }
    }

    static fromJS(data: any): SessionBeginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SessionBeginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["CustomerNumber"] = this.customerNumber;
        data["CustomerRedirectUrl"] = this.customerRedirectUrl;
        data["IsCustomer"] = this.isCustomer;
        data["HasLogin"] = this.hasLogin;
        return data; 
    }
}

export interface ISessionBeginResponse {
    email?: string | undefined;
    customerNumber?: string | undefined;
    customerRedirectUrl?: string | undefined;
    isCustomer: boolean;
    hasLogin: boolean;
}

export class StepResponse implements IStepResponse {
    number!: number;
    heading?: string | undefined;
    method?: string | undefined;

    constructor(data?: IStepResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["Number"];
            this.heading = _data["Heading"];
            this.method = _data["Method"];
        }
    }

    static fromJS(data: any): StepResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StepResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Number"] = this.number;
        data["Heading"] = this.heading;
        data["Method"] = this.method;
        return data; 
    }
}

export interface IStepResponse {
    number: number;
    heading?: string | undefined;
    method?: string | undefined;
}

export class SubscriptionDetailRequest implements ISubscriptionDetailRequest {
    discountCode?: string | undefined;
    deliveryDateId!: number;
    overrideDeliverySlotId?: number | undefined;
    frequency!: SubscriptionDetailRequestFrequency;
    cartId?: string | undefined;
    isOneOffBufferSale?: boolean | undefined;
    shouldUseDefaultCreditCard?: boolean | undefined;

    constructor(data?: ISubscriptionDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.frequency = SubscriptionDetailRequestFrequency._1;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discountCode = _data["discountCode"];
            this.deliveryDateId = _data["deliveryDateId"];
            this.overrideDeliverySlotId = _data["overrideDeliverySlotId"];
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : SubscriptionDetailRequestFrequency._1;
            this.cartId = _data["cartId"];
            this.isOneOffBufferSale = _data["isOneOffBufferSale"];
            this.shouldUseDefaultCreditCard = _data["shouldUseDefaultCreditCard"];
        }
    }

    static fromJS(data: any): SubscriptionDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountCode"] = this.discountCode;
        data["deliveryDateId"] = this.deliveryDateId;
        data["overrideDeliverySlotId"] = this.overrideDeliverySlotId;
        data["frequency"] = this.frequency;
        data["cartId"] = this.cartId;
        data["isOneOffBufferSale"] = this.isOneOffBufferSale;
        data["shouldUseDefaultCreditCard"] = this.shouldUseDefaultCreditCard;
        return data; 
    }
}

export interface ISubscriptionDetailRequest {
    discountCode?: string | undefined;
    deliveryDateId: number;
    overrideDeliverySlotId?: number | undefined;
    frequency: SubscriptionDetailRequestFrequency;
    cartId?: string | undefined;
    isOneOffBufferSale?: boolean | undefined;
    shouldUseDefaultCreditCard?: boolean | undefined;
}

export class TimeSpan implements ITimeSpan {
    ticks?: number | undefined;
    days?: number | undefined;
    hours?: number | undefined;
    milliseconds?: number | undefined;
    minutes?: number | undefined;
    seconds?: number | undefined;
    totalDays?: number | undefined;
    totalHours?: number | undefined;
    totalMilliseconds?: number | undefined;
    totalMinutes?: number | undefined;
    totalSeconds?: number | undefined;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            this.days = _data["days"];
            this.hours = _data["hours"];
            this.milliseconds = _data["milliseconds"];
            this.minutes = _data["minutes"];
            this.seconds = _data["seconds"];
            this.totalDays = _data["totalDays"];
            this.totalHours = _data["totalHours"];
            this.totalMilliseconds = _data["totalMilliseconds"];
            this.totalMinutes = _data["totalMinutes"];
            this.totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data; 
    }
}

export interface ITimeSpan {
    ticks?: number | undefined;
    days?: number | undefined;
    hours?: number | undefined;
    milliseconds?: number | undefined;
    minutes?: number | undefined;
    seconds?: number | undefined;
    totalDays?: number | undefined;
    totalHours?: number | undefined;
    totalMilliseconds?: number | undefined;
    totalMinutes?: number | undefined;
    totalSeconds?: number | undefined;
}

export class UpdateLeadCommand implements IUpdateLeadCommand {
    email!: string;
    primaryProductSku?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    addressId?: number | undefined;
    deliveryInstructions?: string | undefined;
    mobileNumber?: string | undefined;
    cartId?: string | undefined;
    customerContactPreference?: number | undefined;

    constructor(data?: IUpdateLeadCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.primaryProductSku = _data["PrimaryProductSku"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.addressId = _data["AddressId"];
            this.deliveryInstructions = _data["DeliveryInstructions"];
            this.mobileNumber = _data["MobileNumber"];
            this.cartId = _data["CartId"];
            this.customerContactPreference = _data["CustomerContactPreference"];
        }
    }

    static fromJS(data: any): UpdateLeadCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLeadCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["PrimaryProductSku"] = this.primaryProductSku;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["AddressId"] = this.addressId;
        data["DeliveryInstructions"] = this.deliveryInstructions;
        data["MobileNumber"] = this.mobileNumber;
        data["CartId"] = this.cartId;
        data["CustomerContactPreference"] = this.customerContactPreference;
        return data; 
    }
}

export interface IUpdateLeadCommand {
    email: string;
    primaryProductSku?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    addressId?: number | undefined;
    deliveryInstructions?: string | undefined;
    mobileNumber?: string | undefined;
    cartId?: string | undefined;
    customerContactPreference?: number | undefined;
}

export class ValidateAddressResponseDto implements IValidateAddressResponseDto {
    addressId!: number;
    isValid!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IValidateAddressResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressId = _data["AddressId"];
            this.isValid = _data["IsValid"];
            this.errorMessage = _data["ErrorMessage"];
        }
    }

    static fromJS(data: any): ValidateAddressResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateAddressResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AddressId"] = this.addressId;
        data["IsValid"] = this.isValid;
        data["ErrorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface IValidateAddressResponseDto {
    addressId: number;
    isValid: boolean;
    errorMessage?: string | undefined;
}

export class ValidateCodeResponse implements IValidateCodeResponse {
    voucher?: VoucherDto | undefined;
    promo?: PromoDto | undefined;
    raf?: ReferAFriendDto | undefined;
    discount?: Discount2 | undefined;
    validationErrors?: string[] | undefined;

    constructor(data?: IValidateCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voucher = _data["Voucher"] ? VoucherDto.fromJS(_data["Voucher"]) : <any>undefined;
            this.promo = _data["Promo"] ? PromoDto.fromJS(_data["Promo"]) : <any>undefined;
            this.raf = _data["Raf"] ? ReferAFriendDto.fromJS(_data["Raf"]) : <any>undefined;
            this.discount = _data["Discount"] ? Discount2.fromJS(_data["Discount"]) : <any>undefined;
            if (Array.isArray(_data["ValidationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["ValidationErrors"])
                    this.validationErrors!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidateCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Voucher"] = this.voucher ? this.voucher.toJSON() : <any>undefined;
        data["Promo"] = this.promo ? this.promo.toJSON() : <any>undefined;
        data["Raf"] = this.raf ? this.raf.toJSON() : <any>undefined;
        data["Discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        if (Array.isArray(this.validationErrors)) {
            data["ValidationErrors"] = [];
            for (let item of this.validationErrors)
                data["ValidationErrors"].push(item);
        }
        return data; 
    }
}

export interface IValidateCodeResponse {
    voucher?: VoucherDto | undefined;
    promo?: PromoDto | undefined;
    raf?: ReferAFriendDto | undefined;
    discount?: Discount2 | undefined;
    validationErrors?: string[] | undefined;
}

export class VoucherDto implements IVoucherDto {
    voucherId!: number;
    code?: string | undefined;
    value!: number;

    constructor(data?: IVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voucherId = _data["VoucherId"];
            this.code = _data["Code"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): VoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VoucherId"] = this.voucherId;
        data["Code"] = this.code;
        data["Value"] = this.value;
        return data; 
    }
}

export interface IVoucherDto {
    voucherId: number;
    code?: string | undefined;
    value: number;
}

export class VoucherResponse implements IVoucherResponse {
    code?: string | undefined;
    valueOff!: number;
    balance!: number;

    constructor(data?: IVoucherResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.valueOff = _data["ValueOff"];
            this.balance = _data["Balance"];
        }
    }

    static fromJS(data: any): VoucherResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["ValueOff"] = this.valueOff;
        data["Balance"] = this.balance;
        return data; 
    }
}

export interface IVoucherResponse {
    code?: string | undefined;
    valueOff: number;
    balance: number;
}

export enum BenefitDtoBenefitType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum CalculateCostModelDiscountType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum DeliverySlotsGroupedSummaryDeliveryDay {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum Discount2DiscountType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum IngredientResponseIngredientType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum PriceBenefitDtoBenefitType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum PriceBenefitDtoProductSelectorType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum ProductDeliverySlotDtoDeliveryDay {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum PromoDtoDiscountType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum RecipeDtoStockAvailability {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum ReferAFriendDtoDiscountType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum SaleDisplayPriceResponseDiscountSource {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum SubscriptionDetailRequestFrequency {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ApiClientException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiClientException = true;

    static isApiClientException(obj: any): obj is ApiClientException {
        return obj.isApiClientException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiClientException(message, status, response, headers, null);
}

export interface IAuthClientConfig {
  getAuthorization: () => string;
}